import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {ptracGetEntities, ptracPost} from 'src/utilities/ptracApi'
import {parseActiveDirectoryUserId, parseUsernameFromEmail, searchFieldsHaveValues} from 'src/utilities/utils'
import {BAD_REQUEST, OK} from 'http-status-codes'
import {make} from 'vuex-pathify'
import {
  findByCreatedAtBetween,
  findByEntityId,
  findByEntityIdAndCreatedAtBetween,
  findByEntityIdAndLevel,
  findByEntityIdAndLevelAndCreatedAtBetween,
  findByEntityType,
  findByEntityTypeAndCreatedAtBetween,
  findByEntityTypeAndEntityId,
  findByEntityTypeAndEntityIdAndCreatedAtBetween,
  findByEntityTypeAndEntityIdAndLevel,
  findByEntityTypeAndEntityIdAndLevelAndCreatedAtBetween,
  findByEntityTypeAndLevel,
  findByEntityTypeAndLevelAndCreatedAtBetween,
  findByLevel,
  findByLevelAndCreatedAtBetween
} from 'src/utilities/logsSearch'

let initialState = {
  results: [],
  query: {
    entityType: null,
    entityId: null,
    level: Constants.LOG_LEVELS.ERROR,
    createdAt: []
  }
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)

getters.searchFieldsHaveValues = (state) => {
  const searchFields = [
    'entityType',
    'entityId',
    'level',
    'createdAt'
  ]

  return searchFieldsHaveValues(state.query, searchFields)
}

const mutations = make.mutations(state)

mutations.resetQuery = (state) => {
  state.query = JSON.parse(JSON.stringify(initialState.query))
}

mutations.resetResults = (state) => {
  state.results = []
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions: {
    async logLogin({}, claims) {
      await ptracPost('logs', {
        entityType: Constants.ENTITIES.USER,
        entityId: parseActiveDirectoryUserId(claims.sub),
        level: Constants.LOG_LEVELS.INFO,
        message: `${claims.name} authenticated successfully`
      })
    },
    async fetchByEntityIds({ commit }, entityIds) {
      const response = await ptracGetEntities('logs/search/findByEntityIdIn?entityIds=' + entityIds)

      if (OK === response.status) {
        commit('results', response.data)
      }

      return response
    },
    async fetchByEntityId({commit}, payload) {
      const response = await ptracGetEntities('logs/search/' + findByEntityId(payload))

      if (OK === response.status) {
        commit('results', response.data)
      }

      return response
    },
    async fetchByEntityTypeAndLogLevelAndCreatedAt({commit}, payload) {
      const response = await ptracGetEntities('logs/search/' + findByEntityTypeAndLevelAndCreatedAtBetween(payload))

      if (OK === response.status) {
        commit('results', response.data)
      }

      return response
    },
    async fetchByEntityTypeAndEntityId({commit}, payload) {
      const response = await ptracGetEntities('logs/search/' + findByEntityTypeAndEntityId(payload))

      if (OK === response.status) {
        commit('results', response.data)
      }

      return response
    },
    async fetchResults({ state, commit }) {
      let endpoint = ''

      const scenarioFns = [
        findByEntityTypeAndEntityIdAndLevelAndCreatedAtBetween,
        findByEntityTypeAndEntityIdAndLevel,
        findByEntityTypeAndEntityIdAndCreatedAtBetween,
        findByEntityTypeAndLevelAndCreatedAtBetween,
        findByEntityIdAndLevelAndCreatedAtBetween,
        findByEntityTypeAndEntityId,
        findByEntityTypeAndLevel,
        findByEntityTypeAndCreatedAtBetween,
        findByEntityIdAndLevel,
        findByEntityIdAndCreatedAtBetween,
        findByLevelAndCreatedAtBetween,
        findByLevel,
        findByCreatedAtBetween,
        findByEntityId,
        findByEntityType
      ]

      for (const scenarioFn of scenarioFns) {
        const result = scenarioFn(state.query)
        if (result) {
          endpoint = result
          break
        }
      }

      // erroneous coding issue
      if (endpoint.length === 0) {
        return { status: BAD_REQUEST }
      }

      const response = await ptracGetEntities('logs/search/' + endpoint + '&limit=1000')

      if (OK === response.status) {
        commit('results', response.data)
      }

      return response
    }
  }
}
